const getWeightFieldCandidates = (field) => {
  if (field === 'salesPlan') return ['monthly_sales_weight', 'sales_weight']
  if (field === 'markdownPlan') return ['monthly_markdowns_weight', 'markdowns_weight']
  return []
}

const getRawWeight = (record, field) => {
  const candidates = getWeightFieldCandidates(field)
  for (const key of candidates) {
    const value = Number(record?.raw?.[key])
    if (Number.isFinite(value) && value > 0) return value
  }
  return 0
}

export const applyWeightedPeriodTotalEdit = ({ byDate, dates, field, newTotal, clampMin = 0 }) => {
  const list = Array.isArray(dates) ? dates : []
  if (!list.length) return byDate

  const weights = list.map((dt) => getRawWeight(byDate.get(dt), field))
  const totalWeight = weights.reduce((acc, value) => acc + Number(value || 0), 0)

  if (!(totalWeight > 0)) return byDate

  const next = new Map(byDate)
  list.forEach((dt, idx) => {
    const record = next.get(dt)
    if (!record) return
    const weightedValue = Number(newTotal || 0) * (Number(weights[idx] || 0) / totalWeight)
    next.set(dt, {
      ...record,
      [field]: Math.max(clampMin, weightedValue),
    })
  })

  return next
}

